import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PickupRequesticon from "../../Icons/PickupRequesticon";
const PickupRequestListComponent = loadable(
  () => import("../../Components/CourierPickupRequest/CourierPickupRequestList")
);
const CourierPickupRequestList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <PickupRequesticon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Pickup Sheet
        </span>
      </div>
      <PickupRequestListComponent />
    </>
  );
};

export default CourierPickupRequestList;
